import httpService from "..";

export const handleLogin = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/authentication/login`,
    "post",
    data
  );
};

export const handlePasswordCreate = async (token: string, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/authentication/create-password/${token}`,
    "post",
    data
  );
};

export const handlePasswordForgot = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/authentication/forgot-password`,
    "post",
    data
  );
};

export const handlePasswordReset = async (token: string, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/authentication/reset-password/${token}`,
    "post",
    data
  );
};

export const handleLogout = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/authentication/logout`,
    "post",
  );
};
